import { Outlet } from 'react-router-dom';

// Layout for /g/:gameShortId/feedback-settings/*. With the per-page
// sub-rail moved into the global SecondaryNav (and Insights settings
// now under the Insights rail), this layout is just a passthrough -
// the shell's <main> owns scroll so every sub-page shares the same
// content width regardless of length.
export function FeedbackSettingsPage(): JSX.Element {
  return <Outlet />;
}
